import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('contacts', app)
  return store
}
